<template>
	<div class="content-container">
		<div class="header">
			<div class="title">Search For:</div>
		</div>
		<div class="content nopad">
			<div class="sidebar-menu">
				<ul>
					<li v-bind:class="selectedTopic" @click="goTo('topic')">
						<span class="menutext">Topic</span>
					</li>
					<!-- <li v-bind:class="selectedPost" @click="goTo('post')">
						<span class="menutext">Post</span>
					</li> -->
					<!-- <li v-bind:class="selectedAttachement" @click="goTo('attatchment')">
						<span class="menutext">Attatchment</span>
					</li> -->
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	computed: {
		selectedTopic: function () {
			return this.$route.path === "/search/topic" ? "selected" : null;
		},
		selectedPost: function () {
			return this.$route.path === "/search/post" ? "selected" : null;
		},
		selectedAttachement: function () {
			return this.$route.path === "/search/attatchment"
				? "selected"
				: null;
		},
	},

	methods: {
        goTo(path) {
            this.$router.push('/search/' + path);
        }
    },
};
</script>